import { c as _c } from "react/compiler-runtime";
import { StoreImage, StoreImageEnum, getSocialLinkIcon } from '@systemeio/digital-store-shared';
import { STORE_ITEM_BUTTON_CLASS_NAME, STORE_ITEM_CLASS_NAME } from 'modules/stores/store/constants/store-item-class-name';
import { StoreTabEnum } from 'modules/stores/store/enum/store-tab-enum';
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query';
import { StoreInterface } from 'modules/stores/types/stores-interface';
import React, { FC } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import { PenIcon } from '@systemeio/ui/icons';
interface ProfileContentProps {
  profile: StoreInterface['profile'];
  socialMedia: StoreInterface['socialLinks'];
}
const ProfileContent: FC<ProfileContentProps> = t0 => {
  const $ = _c(28);
  const {
    profile,
    socialMedia
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    onChangeTab
  } = useStoreQuery();
  let t1;
  if ($[0] !== onChangeTab) {
    t1 = () => onChangeTab(StoreTabEnum.profile);
    $[0] = onChangeTab;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = twMerge(STORE_ITEM_CLASS_NAME, STORE_ITEM_BUTTON_CLASS_NAME, "flex flex-col items-center gap-5 sm:flex-row sm:items-start");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = profile.sellerPhoto?.path;
  let t4;
  if ($[3] !== profile.sellerName || $[4] !== t3) {
    t4 = <StoreImage imageType={StoreImageEnum.profile} alt={profile.sellerName} src={t3} className="border-brand-primary shrink-0 rounded-full border-2 object-cover" skipTheme={true} />;
    $[3] = profile.sellerName;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== profile.sellerName) {
    t5 = <span className="text-text-primary break-words text-2xl font-bold">{profile.sellerName}</span>;
    $[6] = profile.sellerName;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== profile.bio) {
    t6 = <span className="break-words text-lg">{profile.bio}</span>;
    $[8] = profile.bio;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== socialMedia) {
    t7 = socialMedia.map(_temp);
    $[10] = socialMedia;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <div className="mt-2 flex flex-wrap justify-center gap-1.5">{t7}</div>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t8) {
    t9 = <div className="flex flex-col sm:items-start">{t5}{t6}{t8}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <PenIcon className="fill-brand-primary h-4 w-4" />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("dashboard.store.profile.edit_profile");
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11) {
    t12 = <div className="sm:ml-auto"><div className="flex gap-1">{t10}<span className="text-brand-primary whitespace-nowrap">{t11}</span></div></div>;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t1 || $[24] !== t12 || $[25] !== t4 || $[26] !== t9) {
    t13 = <button onClick={t1} className={t2}>{t4}{t9}{t12}</button>;
    $[23] = t1;
    $[24] = t12;
    $[25] = t4;
    $[26] = t9;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};
export default ProfileContent;
function _temp(media) {
  return <div key={media.type} className="border-text-secondary/30 rounded-md border p-1">{getSocialLinkIcon(media.type, "fill-brand-primary")}</div>;
}